<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import WebsiteLayout from '../components/WebsiteLayout.vue';

const { t } = useI18n();

const headerTitle = computed(() => t('WEBSITE.HEADER.DOMAIN_TITLE'));
</script>

<template>
  <WebsiteLayout :header-title="headerTitle">
    <div
      class="flex flex-col items-center justify-center py-24 rounded-lg bg-gradient-to-br from-n-solid-1 to-n-slate-2 dark:to-n-slate-1 border-2 border-dashed border-n-weak"
    >
      <div
        class="mb-6 w-20 h-20 rounded-full bg-n-blue-2 dark:bg-n-blue-3 flex items-center justify-center"
      >
        <span class="i-lucide-globe size-10 text-n-blue-10" />
      </div>
      <h3 class="text-lg font-semibold text-n-slate-12 mb-2">
        {{ t('WEBSITE.DOMAIN.EMPTY_STATE.TITLE') }}
      </h3>
      <p class="text-sm text-center text-n-slate-10 max-w-md mb-6">
        {{ t('WEBSITE.DOMAIN.EMPTY_STATE.SUBTITLE') }}
      </p>
    </div>
  </WebsiteLayout>
</template>
